module.exports = __webpack_public_path__ + "static/assets/7eafe1f44d0a48f47254d22cd6840109.svg";